import * as $ from 'jquery'

export class Dimension {
	public height: number
	public width: number

	constructor(width: number, height: number) {
		this.height = height
		this.width = width
	}
}

export const renderModal
	= (name: string, title: string, contentsHtml: string, dimension: Dimension, appendCb:(n:Node) => void, onApplyChanges: () => void) => {
		const modal = $('<div id="' + name + '">')
		appendCb(modal.get(0))
		modal.html(contentsHtml)
		modal.find('[name="backButton"]').click(() => modal.dialog('close'))
		modal.find('[name="saveSubmit"]').click(onApplyChanges)
		modal.dialog({
			height: dimension.height,
			width:  dimension.width,
			title:  title,
			autoOpen: false,
		})

		return modal
}

export const showDialog = (id: string, title: string, content: string, width: string ) => {
	// The following functions prevent our dialogs from auto focusing the first element they can find, which
	// can cause unintuitive behaviour for users in some cases (especially with date pickers). The dialog
	// prototype is put back in its default state when the dialog is closed.

	const focusTabbable = $.ui.dialog.prototype._focusTabbable

	const removeAutoFocus = () => {
		$.ui.dialog.prototype._focusTabbable = () =>{}
	}

	const addAutoFocus = () => {
		$.ui.dialog.prototype._focusTabbable = focusTabbable
	}

	//noinspection JSJQueryEfficiency
	if ( $( '#'+id ).length )
		return

	$( 'body' ).append( '<div id="' + id + '">' + content + '</div>' )
	removeAutoFocus()

	//noinspection JSJQueryEfficiency
	const div = $( '#' + id )
	div.dialog( {
		autoOpen:  false,
		modal:     true,
		height:    'auto',
		width:     width,
		title:     title,
		close:     function(this: Element) { addAutoFocus(); $( this ).remove(); }
	} )
	div.dialog( "open" )
}

export const hideDialog = ( id: string ) => {
	$( '#' + id ).dialog( "destroy" ).remove()
}



// WEBPACK FOOTER //
// ./src/legacy/modal.ts